import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import { useSelector } from "react-redux";
import moment from 'moment';
import { usePageVisibility } from 'react-page-visibility';
// components
import SingleQuestion from "./singleQuestion";
import ProgressBar from "./progressBar";
import Results from "./results";
//import Video from "./video";
import VideoTest from "./video_test";
import LoadingView from "../layout/loading";
import { colors } from "../layout/constants";
// services
import { sendQuestionAnswer, sendSnap } from "../../services/test";
// assets
import camaraPermission from "../../assets/images/camaraPermission.png";
import VideocamIcon from "@material-ui/icons/Videocam";
import idx from "idx";

moment.locale('es-MX');
let changePage = false, isOnPage = true;
const QuestionsView = ({ questions, totalQuestions, answredQuestions }) => {
	const user = useSelector((state) => state.user);
	isOnPage = usePageVisibility();
	// state
	const [activeQuestion, _setActiveQuestion] = useState();
	const [selectedIndex, _setSelectedIndex] = useState();
	const [answersCount, _setAnswersCount] = useState(answredQuestions);
	const [hasVideo, _setHasVideo] = useState(false);
	const [askedAllowCamera, setAskedAllowCamera] = useState(false);
	const [allowCamera, setAllowCamera] = useState(false);
	const [videoError, setVideoError] = useState("");
	const [generalErrorMessage, setGeneralErrorMessage] = useState("");
	const [sendingQuestion, _setSendingQuestion] = useState(false);
	const [resetTimer, setResetTimer] = useState(false);
	const [resultsInfo, setResultsInfo] = useState({});
	const [choiceID, setChoiceID] = useState(0);
	const [statusSendQuestion, setStatusSendQuestion] = useState(0);
	const [loadedQuestions, setLoadedQuestions] = useState(false);
	const [stopVideo, setStopVideo] = useState(false);
	const [sendVideo, setSendVideo] = useState(false);
	// ref for window event listener
	const activeQuestionRef = useRef(activeQuestion);
	const setActiveQuestion = (data) => {
		activeQuestionRef.current = data;
		_setActiveQuestion(data);
	};
	const answersCountRef = useRef(answersCount);
	const setAnswersCount = (data) => {
		answersCountRef.current = data;
		_setAnswersCount(data);
	};
	const hasVideoRef = useRef(hasVideo);
	const setHasVideo = (data) => {
		hasVideoRef.current = data;
		_setHasVideo(data);
	};
	const selectedIndexRef = useRef(selectedIndex);
	const setSelectedIndex = (data) => {
		selectedIndexRef.current = data;
		_setSelectedIndex(data);
	};
	const sendingQuestionRef = useRef(sendingQuestion);
	const setSendingQuestion = (data) => {
		sendingQuestionRef.current = data;
		_setSendingQuestion(data);
	};

	useEffect(() => {
		if (!isOnPage) changePage = true;
	}, [isOnPage]);



	useEffect(() => {
		if (
			isOnPage &&
			changePage &&
			hasVideoRef.current &&
			questions.length &&
			!sendingQuestionRef.current
		) {

			setSendingQuestion(true);
			sendAnswer(activeQuestionRef.current, { id: 0 }, "Window change");
			setGeneralErrorMessage(
				"Recuerda que no puedes cambiar de ventana durante la prueba, la respuesta anterior fue tomada como incorrecta."
			);
			changePage = false;
		}
	}, [isOnPage]);

	const selectQuestion = (error) => {
		// console.log(questions.length)
		setResetTimer(false);
		// select random question
		let timerSt = 12000;
		if (error) timerSt = 1000;
		setTimeout(() => {
			if (questions.length) {
				if (!error) {
					const index = Math.floor(Math.random() * questions.length);
					setSelectedIndex(index);
					setActiveQuestion(questions[index]);
				}
				setLoadedQuestions(true);
				setSendingQuestion(false);
				setStatusSendQuestion(0);
			}
		}, timerSt)
	};

	const sendAnswer = async (activeQuestion, answer, conflict) => {
		setGeneralErrorMessage("");
		setResetTimer(true);
		window.scrollTo({ top: 0, behavior: 'smooth' })
		setTimeout(async () => {
			setSendingQuestion(true);
			setStatusSendQuestion(1);
			try {
				const resp = await sendQuestionAnswer(user.token, {
					question_id: activeQuestion.id,
					choice_id: answer.id,
					conflict: conflict,
					responded_at: `${moment(new Date()).format('DD-MM-YYYY')} ${moment(new Date()).format('hh:mm:ss')}`
				});

				const answered = await resp.json();
				setStopVideo(true);
				if (resp.status === 200) {
					setResultsInfo(answered);
					setSendVideo(true);
				}

				if (answered && answered.error_code) {
					setStatusSendQuestion(3);
					resetQuestionTimer("error", answered.error_code, 3);
					setSendVideo(false);
					return;
				}
				setStatusSendQuestion(2);
				resetQuestionTimer('', null, 2);
			} catch (error) {
				setStatusSendQuestion(3);
				resetQuestionTimer("error", null, 3);
				console.error(error);
			}
		}, 800)
	};

	const resetQuestionTimer = (error, code, statusQuestion) => {
		setResetTimer(true);
		if (!error) {
			setAnswersCount(answersCountRef.current + 1);
			if (statusQuestion === 2 || statusQuestion === 3)
				questions.splice(selectedIndexRef.current, 1);
		}

		if (code === 1010) {
			if (statusQuestion === 2 || statusQuestion === 3)
				questions.splice(selectedIndexRef.current, 1)
		}

		selectQuestion(error);
	};

	return (
		<QuestionsStyled>
			{questions.length >= 0 && loadedQuestions ?
				<VideoTest
					setHasVideo={setHasVideo}
					setVideoError={setVideoError}
					answersCount={answersCountRef.current}
					user={user}
					activeQuestion={activeQuestionRef.current}
					allowCamera={allowCamera}
					setAllowCamera={setAllowCamera}
					setAskedAllowCamera={setAskedAllowCamera}
					statusSendQuestion={statusSendQuestion}
					questionsLength={questions.length}
					stopVideo={stopVideo}
					setStopVideo={setStopVideo}
					sendVideoBool={sendVideo}
					setSendVideo={setSendVideo}
					startedNewQuestion={activeQuestion && !videoError && askedAllowCamera && allowCamera &&
						!sendingQuestion}
				//sendingQuestion={sendingQuestion}
				/> :
				<div className="video-loading">
					<VideocamIcon />
				</div>}

			{questions.length > 0 ? (
				<>
					<div className="grid">
						<ProgressBar
							hasVideo={hasVideo}
							totalQuestions={totalQuestions}
							answredQuestions={answersCount}
							sendAnswer={sendAnswer}
							selectQuestion={selectQuestion}
							resetTimer={resetTimer}
							questions={questions}
							activeQuestion={activeQuestion}
							sendingQuestion={sendingQuestion}
							choiceID={choiceID}
						/>
					</div>

					{generalErrorMessage ? (
						<p className="general-error">{generalErrorMessage}</p>
					) : null}

					{activeQuestion && !videoError && askedAllowCamera && allowCamera ? (
						!sendingQuestion ? (
							<SingleQuestion
								activeQuestion={activeQuestion}
								sendAnswer={sendAnswer}
								setChoiceID={setChoiceID}
							/>
						) : (
							<LoadingView message="Enviando respuesta" />
						)
					) : askedAllowCamera && !allowCamera ? (
						<section className="no-camara">
							No tienes la camara activada, es necesario para tomar la
						evaluación. <br />
						Puedes dar click en el recuadro gris de abajo a la derecha para
						activarla.
							{videoError ? (
								<p className="error">
									{videoError} <br /> Si denegaste el permiso por error, puedes
							otorgarlo apretando el simbolo de la camara en la barra de tu
							navegador. <br />
									<br />
									<img src={camaraPermission}></img>
								</p>
							) : null}
						</section>
					) : <LoadingView message="Cargando..." />}
				</>
			) : (
				<Results resultsInfo={resultsInfo} />
			)}
		</QuestionsStyled>
	);
};

const QuestionsStyled = styled.section`
box-sizing: border-box;
display: flex;
min-height: calc(100vh - 80px);
flex-direction: column;
text-align: center;
padding-bottom: 25vh;
z-index: 0;

.general-error {
	color: red;
	text-align: left;
	margin-bottom: 0;
	width: 100%;
	margin: 0 auto;
}

.grid {
	align-items: center;
	display: grid;
	grid-column-gap: 2em;
	grid-template-columns: 1fr;
}

.no-camara {
	font-size: 1rem;
	margin: 4em 0;
}

.error {
	color: red;
	font-size: 1rem;
}

.video-loading {
	align-items: center;
	background-color: #e2e2e2;
	border-radius: 4px;
	color: #8bc34a;
	cursor: pointer;
	display: flex;
	height: 80px;
	justify-content: center;
	position: fixed;
	top: 0px;
    right: 0px;
	width: 115px;
	z-index: 5;

	:hover {
		color: ${colors.primaryLight};
	}
}

.MuiSvgIcon-root {
	font-size: 2em;
}

@media (max-width: 460px) {
	.grid {
		grid-template-columns: 1fr;
	}
}
`;

export default QuestionsView;
